import React from 'react';
import type { Stage } from '@org-avp/avp-hck-dga-customerui-commons';

export interface Config {
  __type?: 'json';
  stage?: Stage;
}

export const ConfigurationContext = React.createContext<Config | undefined>(undefined);

export function useConfigurationContext(): Config | undefined {
  const context = React.useContext(ConfigurationContext);

  if (!context) {
    throw new Error('No ConfgurationContext value was provided.');
  }

  return context;
}
